<template>
  <div class="back">
    <!-- :default-active="activePath" -->
    <el-menu
      :router="true"
      unique-opened
      active-text-color="#fff"
      background-color="rgb(33, 39, 56)"
      text-color="#fff"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect"
      :collapse="isCollapse"
    >
      <!-- logo的显示 -->
      <div class="logo" v-show="!isCollapse">
        <img class="img_yh" v-if="broker_switch==='1'" src="@/assets/index/logo@2x.png" alt=""/>
        <img class="img_ht" v-if="broker_switch==='2'" src="@/assets/index/logo@2xht.png" alt=""/>
        <img class="img_yh" v-if="broker_switch==='3'" src="@/assets/index/logo@2xyg.png" alt=""/>
      </div>
      <div class="logo-mini" v-show="isCollapse">
        <img class="img_yh" v-if="broker_switch==='1'" src="@/assets/index/logo-mini@2x.png" alt=""/>
        <img class="img_ht" v-if="broker_switch==='2'" src="@/assets/index/logo-mini@2xht.png" alt=""/>
        <img class="img_yh" v-if="broker_switch==='3'" src="@/assets/index/logo-mini@2xyg.png" alt=""/>
      </div>

      <!-- menu的遍历 -->
      <el-menu-item
        :index="item.path"
        v-for="item in noChildren"
        :key="item.path"
        :style="{ order: item.order }"
        @click="clickMenu(item)"
      >
        <i :class="'el-icon-' + item.icon"></i>
        <template #title>{{ item.label }}</template>
      </el-menu-item>

      <el-submenu
        :index="item.name"
        v-for="(item, index) in hasChildren"
        :key="index"
        :order="item.order"
      >
        <template #title>
          <i :class="'el-icon-' + item.icon"></i>
          <span>{{ item.label }}</span>
        </template>
        <!-- 二级菜单  -->
        <template v-for="subItem in item.children" :key="subItem">
          <el-submenu
            v-if="subItem.list && subItem.list.length"
            :index="subItem.path"
            class="secondSubmenu"
          >
            <template #title>
              <span>{{ subItem.label }}</span>
            </template>
            <!-- 三级菜单  -->
            <el-menu-item
              v-for="thirdItem in subItem.list"
              :key="thirdItem.path"
              :index="thirdItem.path"
              @click="clickMenu(thirdItem)"
              class="el-menu-item-background-color"
            >
              <span>{{ thirdItem.label }}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item
            v-else
            :index="subItem.path"
            @click="clickMenu(subItem)"
            class="el-menu-item-background-color"
          >
            <span>{{ subItem.label }}</span>
          </el-menu-item>
        </template>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
  import {ElMessage} from "element-plus";

  export default {
    //计算属性
    computed: {
      //没有子菜单
      noChildren() {
        return this.menu.filter((item) => !item.children);
      },
      //有子菜单
      hasChildren() {
        return this.menu.filter((item) => item.children);
      },
      isCollapse() {
        // 这里的数据就是从vuex取的
        return this.$store.state.tabs.isCollapse;
      },
    },
    beforeCreate() {
      //通过检测token判断通过路由直接登录校验
      if (sessionStorage.getItem("token") == null) {
        this.$router.push({name: "Login"});
      }
    },
    mounted() {
      // ElMessage({
      //   showClose: true,
      //   message: "ssoLogin:",
      //   type: "error",
      // });
      //this.activePath = this.$route.path;
    },
    watch: {
      //监视路由
      // $route(to) {
      //   this.activePath = to.path;
      // },
    },
    data() {
      return {
        broker_switch: "",
        activePath: "",
        bar: [],
        menu: [
          {
            path: "/index",
            name: "Index",
            label: "首页",
            m_id: "010000",
            icon: "s-home",
            order: 0,
          },

          {
            label: "预警",
            name: "alert",
            m_id: "020000",
            icon: "message-solid",
            order: 1,
            children: [
              {
                path: "/alert/databoard",
                name: "Databoard",
                label: "预警-数据面板",
                m_id: "020100",
                icon: "setting",
              },
              {
                path: "/alert/supervise",
                name: "Supervise",
                label: "监控管理",
                m_id: "020200",
                icon: "setting",
              },
              {
                path: "/alert/dataSearch",
                name: "DataSearch",
                label: "数据查询",
                m_id: "020300",
                icon: "setting",
              },

            ],
          },
          {
            label: "ETL服务检测",
            name: "etl",
            m_id: "030000",
            icon: "s-order",
            order: 2,
            children: [
              {
                path: "/etl/etlDashboard",
                name: "EtlDashboard",
                label: "ETL-数据面板",
                m_id: "030100",
                icon: "setting",
              },
              {
                path: "/etl/etlTaskList",
                name: "EtlTaskList",
                label: "任务列表",
                m_id: "030200",
                icon: "setting",
              },
              {
                path: "/etl/etlTaskConfig",
                name: "EtlTaskConfig",
                label: "任务配置",
                m_id: "030500",
                icon: "setting",
              },
              {
                path: "/etl/etlMyMessage",
                name: "EtlMyMessage",
                label: "我的消息",
                m_id: "030300",
                icon: "setting",
              },
              {
                path: "/etl/etlConfig",
                name: "EtlConfig",
                label: "检测配置",
                m_id: "030400",
                icon: "setting",
              },
            ],
          },
          {
            label: "堆栈监控",
            name: "stack",
            m_id: "040000",
            icon: "monitor",
            order: 3,
            children: [
              {
                path: "/stack/es",
                name: "Es",
                label: "Elasticsearch",
                m_id: "040100",
                icon: "setting",
              },
              {
                path: "/stack/kafka",
                name: "Kafka",
                label: "Kafka",
                m_id: "040200",
                icon: "setting",
              },
              {
                path: "/stack/redis",
                name: "Redis",
                label: "Redis",
                m_id: "040300",
                icon: "setting",
              },
            ],
          },
          {
            label: "堆栈管理",
            name: "stack_manage",
            m_id: "060000",
            icon: "cpu",
            order: 3,
            children: [
              {
                path: "/stack_manage/ES",
                name: "Es",
                label: "Elasticsearch",
                m_id: "060100",
                icon: "setting",
                list: [
                  {
                    path: "/stack_manage/ES/ilm/0",
                    name: "Ilm",
                    label: "索引生命周期",
                    m_id: "060101",
                    icon: "setting",
                  },
                  {
                    path: "/stack_manage/ES/ilm_applied/0",
                    name: "Ilm_applied",
                    label: "索引管理",
                    m_id: "060101",
                    icon: "setting",
                  },
                ],
              },
              {
                path: "/stack_manage/RedisManage",
                name: "RedisManage",
                m_id: "060200",
                label: "Redis",
                icon: "setting",
              },
            ],
          },
          {
            label: "跨集群复制",
            name: "cross_copy_manage",
            m_id: "110000",
            icon: "copy-document",
            order: 3,
            children: [
              {
                path: "/cross_copy_manage/ccr_manage",
                name: "ccr_manage",
                label: "ccr管理",
                m_id: "110100",
                icon: "setting",
              },
              {
                path: "/cross_copy_manage/ZB_switching",
                name: "ZB_switching",
                m_id: "110200",
                label: "主备集群切换说明",
                icon: "setting",
              },
            ],
          },
          {
            label: "搜索模板",
            name: "SearchTemplate",
            m_id: "050000",
            icon: "document-copy",
            order: 4,
            children: [
              {
                path: "/search/dashboard",
                name: "网关面板",
                label: "网关面板",
                m_id: "050400",
                icon: "setting",
              },
              {
                path: "/search/template_search",
                name: "搜索",
                label: "搜索",
                m_id: "050100",
                icon: "setting",
              },
              {
                path: "/search/template_manage/0",
                name: "模板管理",
                m_id: "050200",
                label: "模板管理",
                icon: "setting",
              },
              {
                path: "/search/func_group",
                name: "功能组管理",
                m_id: "050300",
                label: "功能组管理",
                icon: "setting",
              },
            ],
          },

          {
            label: "巡检",
            name: "diagnose",
            m_id: "070000",
            icon: "refresh",
            order: 3,
            children: [
              {
                path: "/diagnose/IntelligentPatro",
                name: "IP",
                label: "智能巡检",
                m_id: "070100",
                icon: "setting",
              },
            ],
          },
          {
            path: "/sqlAnalysisSearch",
            name: "sqlSearch",
            label: "SQL解析查询",
            m_id: "080000",
            icon: "coin",
            order: 0,
             children: [
              {
                path: "/sqlAnalysisSearch/sql_earch",
                name: "SQL搜索",
                label: "SQL搜索",
                m_id: "100100",
                icon: "s-tools",
              },
            ],
          },
          {
            path: "/dataMigration",
            name: "dataMigration",
            label: "数据迁移",
            m_id: "100000",
            icon: "copy-document",
            order: 0,

             children: [
              {
                path: "/dataMigration/data_migration_select",
                name: "索引迁移",
                label: "索引迁移",
                m_id: "100100",
                icon: "s-tools",
              },
            ],
          },

          {
            path: "/wordsManage",
            name: "wordsManage",
            label: "词库管理",
            m_id: "090000",
            icon: "tickets",
            order: 88,
            children: [
              {
                path: "/wordsManage/ik_expand",
                name: "ik扩展词库",
                label: "ik扩展词库",
                m_id: "090100",
                icon: "s-tools",
              },
              {
                path: "/wordsManage/ik_setting_desc",
                name: "ik配置说明",
                label: "ik配置说明",
                m_id: "090200",
                icon: "s-tools",
              },
            ],
          },
          {
            label: "系统管理",
            name: "System",
            m_id: "990000",
            icon: "s-tools",
            order: 99,
            children: [
              {
                path: "/system/sysconfig",
                name: "Es",
                label: "用户管理",
                m_id: "990100",
                icon: "s-tools",
              },
              {
                path: "/system/role_manage",
                name: "角色管理",
                label: "角色管理",
                m_id: "990200",
                icon: "setting",

              },
              {
                label: "数据管理",
                m_id: "990300",
                list: [
                  {
                    path: "/system/meta/dataName",
                    name: "DataName",
                    label: "数据名",
                    m_id: "990301",
                    icon: "setting",
                  },
                  {
                    path: "/system/meta/dataSource",
                    name: "DataSource",
                    label: "数据源",
                    m_id: "990302",
                    icon: "setting",
                  },
                ],
              },
              // {
              //   path: "/system/ik_expand",
              //   name: "ik扩展词库",
              //   label: "ik扩展词库",
              //   m_id: "990400",
              //   icon: "s-tools",
              // },
            ],
          },

        ],
      };
    },
    methods: {
      // 跳转路由 根据名称跳转
      clickMenu(item) {
        //console.log("debug:"+item);
        console.log({name: item.path})
        this.$router.push({name: item.path});
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      // 遍历数组,查看权限
      menu_limits(menu_limit) {
        var del_list = [];
        for (let i = 0; i < this.menu.length; i++) {
          // 一级菜单
          // if (this.menu[i].m_id === "990000"){
          if (menu_limit.includes(this.menu[i].m_id)) {
            // 二级菜单
            if (this.menu[i].children) { // 如果有二级子菜单，判断
              var del_list2 = [];
              for (let j = 0; j < this.menu[i].children.length; j++) {
                if (menu_limit.includes(this.menu[i].children[j].m_id)) {
                  if (this.menu[i].children[j].list) { // 如果有三级子菜单，判断
                    var del_list3 = [];
                    for (let k = 0; k < this.menu[i].children[j].list.length; k++) {
                      if (menu_limit.includes
                      (this.menu[i].children[j].list[k].m_id)) {

                      } else {
                        del_list3.push(k)
                      }
                    }
                    del_list3 = del_list3.reverse();
                    for (let k = 0; k < del_list3.length; k++) {
                      this.menu[i].children[j].list.splice(del_list3[k], 1);
                    }

                  }
                } else {
                  del_list2.push(j)
                }
              }
              del_list2 = del_list2.reverse();
              for (let j = 0; j < del_list2.length; j++) {
                this.menu[i].children.splice(del_list2[j], 1);
              }
            }

          } else {
            del_list.push(i)
          }

        }

        del_list = del_list.reverse();
        for (let i = 0; i < del_list.length; i++) {
          this.menu.splice(del_list[i], 1);
        }


      },

    },
    mounted: function () {
      // console.log("===config.request_http2===",config.broker_switch);
      this.broker_switch = config.broker_switch
      // console.log("==========sessionStorage.getItem========1======")
      // console.log(sessionStorage.getItem("limit_menu"))
      // console.log("==========sessionStorage.getItem========2======")
      this.menu_limits(sessionStorage.getItem("limit_menu"))
      // console.log("==========this.menu========1======")
      //     console.log(this.menu)
      //     console.log("==========this.menu========2======")
    }
  };
</script>
<style scoped>
  .router-link-active {
    /* vue-router提供了这个类 */
    color: red;
    font-weight: 800;
    font-style: italic;
    text-decoration: underline;
  }

  .back {
    height: 100%;
  }

  .el-menu-item {
    height: 44px;
    line-height: 44px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
    height: 100%;
  }

  .el-menu-vertical-demo {
    display: flex;
    flex-direction: column;
  }

  .el-menu,
  .el-submenu__title {
    height: 100%;
  }

  .el-submenu >>> .el-submenu__title {
    height: 44px;
    line-height: 44px;
  }

  .logo {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .logo > .img_yh {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
    padding: 20px 15px;
  }
  .logo > .img_ht {
    text-align: center;
    width: 100%;
  }

  .logo-mini {
    display: flex;
    justify-content: center;
  }

  .logo-mini > img {
    padding: 20px 0;
    width: 40px;
  }

  .el-menu-item-background-color {
    background-color: rgba(255, 255, 255, 0.1) !important;
  }

  .el-menu-item.is-active {
    background-color: rgba(64, 158, 255, 1) !important;
  }

  .secondSubmenu /v-deep/ .el-submenu__title {
    background-color: rgba(255, 255, 255, 0.1) !important;
  }
</style>
